import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    tableHeadContainer: {
      borderBottom: `2px solid ${theme.palette.primary.main}`,
    },
    summaryContainer: {
      '& .MuiAccordionSummary-content': {
        margin: '0px !important',
      },
    },
    summaryGrid: {
      height: 110,
      '& tbody td, thead th': {
        border: 'none',
      },
    },
    summaryIconButton: {
      background: theme.palette.primary.main,
      color: theme.palette.secondary.main,

      '&:hover': {
        background: theme.palette.primary.main,
        color: theme.palette.secondary.main,
        opacity: 0.5,
        transition: `${theme.transitions.duration.standard / 1000}s`,
      },
    },
    detailsContainer: {
      paddingTop: theme.spacing(2),
      borderTop: `1px  solid ${theme.palette.divider}`,
      boxShadow: `inset 0 2px 2px 0px ${theme.palette.divider}`,
      background: theme.palette.background.default,
    },
    detailsTabContainer: {
      boxShadow: 'none',
    },

    dividerRow: {
      height: `6px`,
      borderTop: `0px solid ${theme.palette.background.default}`,
      borderBottom: `8px solid ${theme.palette.background.default}`,
    },
  });
});
